<template>
  <div id="vapp">
    <b-sidebar type="is-light" :fullheight="fullheight" :fullwidth="fullwidth" :overlay="overlay" :right="right" :open.sync="open" :can-cancel="false">
      <section>
        <div id="sidebarCross" @click="closeSidebar">X</div>
        <b-tabs v-model="activeTab">
          <b-tab-item label="Settings" :visible="this.instanceSettings.length != 0">
            <b-field :label="setting.settings_name" v-for="setting in this.instanceSettings" :key="setting.settings_name" label-position="on-border">
              <b-input v-if="setting.isDefault" :placeholder="setting.default_value" expanded disabled></b-input>
              <template v-else>
                <template v-if="setting.settings_type == 'agent'">
                  <b-select v-model="setting.settings_value" expanded>
                    <option v-for="agent in agents" :value="agent.extension" :key="agent.extension">({{ agent.extension }}) - {{ agent.name }}</option>
                  </b-select>
                </template>
                <template v-else-if="setting.settings_type == 'queue'">
                  <b-select v-model="setting.settings_value" expanded>
                    <option v-for="queue in queues" :value="queue.queue" :key="queue.queue">{{ queue.queue }} - {{ queue.label }}</option>
                  </b-select>
                </template>
                <template v-else-if="setting.settings_type == 'language'">
                  <b-select v-model="setting.settings_value" expanded>
                    <option v-for="language in languages" :value="language.code" :key="language.code">{{ language.name }} - {{ language.code }}</option>
                  </b-select>
                </template>
                <template v-else-if="setting.settings_type == 'timezone'">
                  <b-select v-model="setting.settings_value" expanded>
                    <option v-for="timezone in timezones" :value="timezone" :key="timezone">
                      {{ timezone }}
                    </option>
                  </b-select>
                </template>
                <template v-else-if="setting.settings_type == 'bool'">
                  <b-select v-model="setting.settings_value" expanded>
                    <option value="true">true</option>
                    <option value="false">false</option>
                  </b-select>
                </template>
                <template v-else-if="setting.settings_type == 'number'">
                  <input type="number" v-model="setting.settings_value" class="input" />
                </template>
                <template v-else-if="setting.settings_type == 'string'">
                  <b-input v-model="setting.settings_value" expanded></b-input>
                </template>
                <template v-else-if="setting.settings_type == 'inputtype'">
                  <b-select v-model="setting.settings_value" expanded>
                    <option value="DTMF">DTMF</option>
                    <option value="speech">speech</option>
                  </b-select>
                </template>
                <template v-else>
                  <b-input v-model="setting.settings_value" expanded></b-input>
                </template>
              </template>

              <b-checkbox v-model="setting.isDefault"> UsingDefault? </b-checkbox>
            </b-field>
          </b-tab-item>
          <b-tab-item label="TTS" :visible="this.instanceTTS.length != 0">
            <b-tabs>
              <b-tab-item v-for="(language, index) in this.languages.filter((x) => x.enabled == true)" :key="language.language_id" :label="language.name" :value="index.toString()">
                <div v-if="instanceTTS">
                  <b-field class="columns" :label="tts.tag" v-for="tts in instanceTTS.filter((tts) => tts.language_id == language.language_id)" :key="tts.tag" label-position="on-border">
                    <b-input class="column is-three-quarters" v-if="tts.isDefault" :placeholder="tts.default_value" expanded disabled></b-input>
                    <b-input class="column is-three-quarters" v-else v-model="tts.content" expanded></b-input>
                    <b-checkbox v-if="tts.isDefault" v-model="tts.default_beep" true-value="&beep" false-value="" disabled> Beep </b-checkbox>
                    <b-checkbox v-else v-model="tts.beep" true-value="&beep" false-value=""> Beep </b-checkbox>
                    <b-checkbox v-model="tts.isDefault"> Default </b-checkbox>
                    <b-button v-if="tts.isDefault" type="is-success" icon-right="play" @click="playtts(tts.default_value)"> </b-button>
                    <b-button v-else type="is-success" icon-right="play" @click="playtts(tts.content)"> </b-button>
                  </b-field>
                </div>
              </b-tab-item>
            </b-tabs>
          </b-tab-item>
        </b-tabs>
        <b-button class="save" type="is-success" @click="saveSidebar">SAVE</b-button>
      </section>
      <b-loading :is-full-page="false" :active="loading"></b-loading>
    </b-sidebar>

    <b-modal :active.sync="isPlayTtsActive" has-modal-card trap-focus :destroy-on-hide="true" aria-role="dialog" aria-modal>
      <play-tts :message="this.message" :settings="this.companySettings" :companies="this.companies" :languages="this.languages"></play-tts>
    </b-modal>
    <div>
      <div class="wrapper">
        <div class="col">
          <div class="blockelem create-flowy noselect" v-for="(module, index) in this.flow" :key="module.module_id">
            <div style="margin: 10px" draggable="true" v-on:dragstart="drag" :data-node="index" :id="module.module_name">{{ module.module_name }}</div>
          </div>
        </div>
        <div class="col-right">
          <div id="drawflow" v-on:drop="drop" v-on:dragover="allowDrop" @wheel="zoom">
            <div class="bar-zoom">
              <i class="fas fa-search-minus" v-on:click="zoomOut"></i>
              <i class="fas fa-search" v-on:click="zoomReset"></i>
              <i class="fas fa-search-plus" v-on:click="zoomIn"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
var Drawflow = require("drawflow");
var styleDrawflow = require("drawflow/dist/drawflow.min.css");
const moment = require("moment-timezone");
const _ = require("lodash");

const axios = require("axios");
const urlParams = new URLSearchParams(window.location.search);
const flowId = urlParams.get("flowid");
const PlayTts = {
  props: {
    message: {
      type: String,
      required: true,
    },
    companies: {
      type: Array,
      required: true,
    },
    settings: {
      type: Array,
      required: true,
    },
    languages: {
      type: Array,
      required: true,
    },
  },
  data: function () {
    return {
      companyId: 0,
      languageId: 0,
      path: "",
      variables: [],
      replacements: {},
      ttsMessage: "",
    };
  },
  mounted() {
    this.variables = this.message.match(/\$\{.{1,40}\}/g);
    this.ttsMessage = this.message;
  },
  methods: {
    getSample() {
      let ttsurl = new URL(this.settings[this.companyId].perlanguage[this.languageId].tts_url).searchParams;
      let ttsregion = this.settings[this.companyId].perlanguage[this.languageId].tts_url.replace("http://", "").split("/")[0];
      this.path = this.apiUrl + `/tts/sample?ttsregion=` + ttsregion + `&ttsprovider=` + ttsurl.get("provider") + `&ttsvoice=` + ttsurl.get("name") + `&message=` + encodeURI(this.ttsMessage);
    },
    updateVariable(input, variable) {
      this.replacements[variable] = input;
      this.updateMessage();
    },
    updateMessage() {
      this.ttsMessage = this.message;
      for (const [key, value] of Object.entries(this.replacements)) {
        this.ttsMessage = this.ttsMessage.replace(`${key}`, `${value}`);
      }
    },
  },
  template: `<div class="modal-card" style="width: fit-content">
                    <header class="modal-card-head">
                        <p class="modal-card-title">Play TTS Message</p>
                    </header>
                    <section class="modal-card-body">
                      <b-field label="Company">
                        <b-select v-model="companyId">
                          <option v-for="company in companies" :value="company.id">
                            {{company.company_name}}
                          </option>
                        </b-select>
                      </b-field>
                      <b-field label="Language">
                        <b-select v-model="languageId">
                          <option v-for="language in languages" :value="language.language_id">
                            {{language.name}}
                          </option>
                        </b-select>
                      </b-field>
                      <b-field v-for="variable in variables" :label="variable">
                        <b-input @input="updateVariable($event, variable)"></b-input>
                      </b-field>
                      {{ttsMessage}}
                      <b-field>
                        <b-button type="is-warning" @click="getSample()">Load Sample</b-button>
                      </b-field>
                      <audio v-if="!this.loading" ref="callRecordingPlayer" :src="path" controls="false" autoplay></audio>
                    </section>
                    <footer class="modal-card-foot">
                        <button class="button" type="button" @click="$parent.close()">Close</button>
                    </footer>
                </div>`,
};
export default {
  components: {
    PlayTts,
  },
  data: function () {
    return {
      flow: [],
      mouseDown: false,
      transformX: 0,
      transformY: 0,
      previousX: 0,
      previousY: 0,
      flowObj: null,
      editor: null,
      loading: true,
      //Sidebar
      open: false,
      overlay: false, // Whether to black out rest of screen
      fullheight: true,
      fullwidth: false,
      right: true,

      instanceSettings: [],
      instanceTTS: [],
      openInstanceId: -1,
      languages: [],
      //tabs
      activeTab: 0,
      activeTabLanguages: 0,
      doubleClickId: -1,
      doubleClickLastClick: Date.now(),
      agents: [],
      queues: [],
      timezones: [],
      selectedNode: null,
      message: "",
      companySettings: [],
      companies: [],
      isPlayTtsActive: false,
      apiUrl: "https://api.jeak.co.uk",
    };
  },
  methods: {
    initFlowy: async function () {
      this.loading = true;
      var id = document.getElementById("drawflow");
      this.editor = new Drawflow(id, Vue);
      this.editor.reroute = true;
      this.editor.reroute_fix_curvature = true;
      this.editor.curvature = 0.5; // Default no reroute
      this.editor.reroute_curvature_start_end = 0.5;
      this.editor.reroute_curvature = 0.5; // (Other reroutes)
      this.editor.start();
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };

      axios
        .get(this.apiUrl + `/flows/${flowId}`, config)
        .then((response) => {
          for (let node of response.data.routing) {
            var htmlOutputs = "";

            for (const flow of this.flow) {
              if (flow.module_id == node.module.module_id) {
                flow.outputs.forEach((output) => {
                  htmlOutputs += "<li>" + output.name + "</li>";
                });

                var moduleName = node.module.module_name;

                if (moduleName == "init") moduleName = "Call Started";

                var html = `
                          <div style="display:flex">
                            <div class="title-box" style="display: inline-block;">${moduleName}</div>
                            <div style="display: inline-block;padding-left: 20px;"><ul>${htmlOutputs}</ul></div>
                          </div>`;

                var data = {
                  module_id: flow.module_id,
                  output_ids: [],
                };

                for (let output in flow.outputs) {
                  data.output_ids.push(flow.outputs[output].id);
                }

                this.editor.nodeId = node.instance_id;
                if (moduleName == "Call Started") {
                  this.editor.addNode(flow.module_name, 0, flow.outputs.length, node.x, node.y, flow.module_name, data, html, false);
                } else {
                  this.editor.addNode(flow.module_name, 1, flow.outputs.length, node.x, node.y, flow.module_name, data, html, false);
                }
              }
            }
          }

          for (let node of response.data.routing) {
            for (let output in node.outputs) {
              var outputObj = node.outputs[output];
              var from = this.editor.getNodeFromId(node.instance_id);

              var index = from.data.output_ids.indexOf(outputObj.output_id);
              var indexPlus = index + 1;

              this.editor.addConnection(node.instance_id, outputObj.next_instance_id, "output_" + indexPlus, "input_1");
            }
          }

          this.SetupEventHandlers();

          let zoomAmount = response.data.zoom;

          const canvas_x = response.data.pos_x;
          const canvas_y = response.data.pos_y;

          if (zoomAmount > this.editor.zoom_max) zoomAmount = this.editor.zoom_max;
          if (zoomAmount < this.editor.zoom_max) zoomAmount = this.editor.zoom_min;

          if (zoomAmount != 1) {
            this.editor.zoom_last_value = this.editor.zoom;
            this.editor.zoom = zoomAmount;
            this.editor.zoom_refresh();
          }

          this.editor.canvas_x = canvas_x;
          this.editor.canvas_y = canvas_y;
          let storedZoom = this.editor.zoom;
          this.editor.zoom = 1;
          this.editor.precanvas.style.transform = "translate(" + this.editor.canvas_x + "px, " + this.editor.canvas_y + "px) scale(" + this.editor.zoom + ")";
          this.editor.zoom = storedZoom;
          this.editor.zoom_last_value = 1;
          this.editor.zoom_refresh();

          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });

      this.editor.on("nodeMoved", async (id) => {
        if (this.loading) return;

        var node = this.editor.getNodeFromId(id);

        var pos = {
          canvas_x: Math.round(node.pos_x),
          canvas_y: Math.round(node.pos_y),
        };
        const token = await this.$cognitoAuth.getIdToken();
        const config = {
          headers: { Authorization: `Bearer ` + token },
        };

        axios
          .put(this.apiUrl + `/flows/${flowId}/nodes/${id}/position`, pos, config)
          .then((response) => {})
          .catch((error) => {
            console.error(error);
          });
      });
      this.editor.on("nodeCreated", async (id) => {
        if (this.loading) return;
        var node = this.editor.getNodeFromId(id);

        this.SetupEventHandlers();

        var nodeObj = {
          instance_id: id,
          module_id: node.data.module_id,
          flow_id: flowId,
          canvas_x: Math.round(node.pos_x),
          canvas_y: Math.round(node.pos_y),
        };

        const token = await this.$cognitoAuth.getIdToken();
        const config = {
          headers: { Authorization: `Bearer ` + token },
        };
        axios
          .post(this.apiUrl + `/flows/${flowId}/nodes`, nodeObj, config)
          .then((response) => {})
          .catch((error) => {
            console.error(error);
          });
      });

      this.editor.on("nodeRemoved", async (id) => {
        if (this.loading) return;
        this.SetupEventHandlers();
        const token = await this.$cognitoAuth.getIdToken();
        const config = {
          headers: { Authorization: `Bearer ` + token },
        };
        axios
          .delete(this.apiUrl + `/flows/${flowId}/nodes/${id}`, config)
          .then((response) => {})
          .catch((error) => {
            console.error(error);
          });
      });

      this.editor.on("connectionCreated", async (connection) => {
        if (this.loading) return;

        var from = this.editor.getNodeFromId(connection.output_id);
        if (from.outputs[connection.output_class].connections.length > 1) {
          this.editor.removeSingleConnection(connection.output_id, connection.input_id, connection.output_class, connection.input_class);
          return;
        }

        var outputIndex = connection.output_class.replace("output_", "");

        var connectionObj = {
          instance_id: connection.output_id,
          output_id: from.data.output_ids[outputIndex - 1],
          next_instance_id: connection.input_id,
        };

        const token = await this.$cognitoAuth.getIdToken();
        const config = {
          headers: { Authorization: `Bearer ` + token },
        };
        axios
          .post(this.apiUrl + `/flows/${flowId}/nodes/${connection.output_id}/connection`, connectionObj, config)
          .then((response) => {})
          .catch((error) => {
            console.error(error);
          });
      });

      this.editor.on("connectionRemoved", async (connection) => {
        if (this.loading) return;

        var from = this.editor.getNodeFromId(connection.output_id);
        /*           if (from.outputs[connection.output_class].connections.length == 1) {
                      //We are removing a double output - IE someone tried to make 2 connections from 1 output
                      return;
                    } */

        var outputIndex = connection.output_class.replace("output_", "");

        const output_id = from.data.output_ids[outputIndex - 1];

        const token = await this.$cognitoAuth.getIdToken();
        const config = {
          headers: { Authorization: `Bearer ` + token },
        };
        axios
          .delete(this.apiUrl + `/flows/${flowId}/nodes/${connection.output_id}/connection/${output_id}`, config)
          .then((response) => {})
          .catch((error) => {
            console.error(error);
          });
      });

      this.editor.on("nodeSelected", (id) => {
        this.selectedNode = id;
      });

      //this.editor.on("addReroute", async (id) => {});
    },
    playtts(message) {
      this.message = message;
      this.isPlayTtsActive = true;
    },
    async GetCompanies() {
      this.companies = [];
      this.companySetting = [];
    },
    SetupEventHandlers: function () {
      var elements = document.getElementsByClassName("drawflow-node");

      for (var i = 0; i < elements.length; i++) {
        elements[i].removeEventListener("click", this.DoubleClickHandler, false);
        elements[i].addEventListener("click", this.DoubleClickHandler, false);
      }
    },
    DoubleClickHandler() {
      const id = this.selectedNode;
      if (this.open) {
        if (id != this.openInstanceId) {
          this.openSidebar(id);
        }
      } else {
        if (this.doubleClickId == id) {
          const difference = (Date.now() - this.doubleClickLastClick) / 1000;
          if (difference < 0.75) {
            this.openSidebar(id);
          }
          this.doubleClickLastClick = Date.now();
          this.doubleClickId = -1;
        } else {
          this.doubleClickId = id;
          this.doubleClickLastClick = Date.now();
        }
      }
    },
    getOuput: function () {
      console.info(this.flowObj.output());
    },
    drag: function (ev) {
      if (ev.type === "touchstart") {
        mobile_item_selec = ev.target.closest(".drag-drawflow").getAttribute("data-node");
      } else {
        ev.dataTransfer.setData("node", ev.target.getAttribute("data-node"));
      }
    },
    drop: function (ev) {
      if (ev.type === "touchend") {
        var parentdrawflow = document.elementFromPoint(mobile_last_move.touches[0].clientX, mobile_last_move.touches[0].clientY).closest("#drawflow");
        if (parentdrawflow != null) {
          this.addNodeToDrawFlow(mobile_item_selec, mobile_last_move.touches[0].clientX, mobile_last_move.touches[0].clientY);
        }
        mobile_item_selec = "";
      } else {
        ev.preventDefault();
        var moduleindex = ev.dataTransfer.getData("node");
        var module = this.flow[moduleindex];

        this.addNodeToDrawFlow(ev.clientX, ev.clientY, module);
      }
    },
    allowDrop: function (ev) {
      ev.preventDefault();
    },
    addNodeToDrawFlow: function (pos_x, pos_y, node) {
      if (this.editor.editor_mode === "fixed") {
        return false;
      }
      pos_x =
        pos_x * (this.editor.precanvas.clientWidth / (this.editor.precanvas.clientWidth * this.editor.zoom)) -
        this.editor.precanvas.getBoundingClientRect().x * (this.editor.precanvas.clientWidth / (this.editor.precanvas.clientWidth * this.editor.zoom));
      pos_y =
        pos_y * (this.editor.precanvas.clientHeight / (this.editor.precanvas.clientHeight * this.editor.zoom)) -
        this.editor.precanvas.getBoundingClientRect().y * (this.editor.precanvas.clientHeight / (this.editor.precanvas.clientHeight * this.editor.zoom));

      var htmlOutputs = "";

      node.outputs.forEach((output) => {
        htmlOutputs += "<li>" + output.name + "</li>";
      });

      var data = {
        module_id: node.module_id,
        output_ids: [],
      };

      for (let outputId in node.outputs) {
        data.output_ids.push(node.outputs[outputId].id);
      }

      if (node.module_name == "init") {
        var html = `
                <div style="display:flex">
                  <div class="title-box" style="display: inline-block;">Call Started</div>
                  <div style="display: inline-block;padding-left: 20px;"><ul>${htmlOutputs}</ul></div>
                </div>`;
        this.editor.addNode(node.module_name, 0, node.outputs.length, pos_x, pos_y, node.module_name, data, html);
      } else {
        var html = `
                <div style="display:flex">
                  <div class="title-box" style="display: inline-block;">${node.module_name}</div>
                  <div style="display: inline-block;padding-left: 20px;"><ul>${htmlOutputs}</ul></div>
                </div>`;
        this.editor.addNode(node.module_name, 1, node.outputs.length, pos_x, pos_y, node.module_name, data, html);
      }
    },
    clearChart: function () {
      this.editor.clearModuleSelected();
    },
    zoomIn: function () {
      this.editor.zoom_in();
    },
    zoomOut: function () {
      this.editor.zoom_out();
    },
    zoomReset: function () {
      this.editor.zoom_reset();
    },
    zoom: function (event) {
      if (event.deltaY > 0) {
        this.zoomOut();
      } else {
        this.zoomIn();
      }
    },
    openSidebar: async function (instanceId) {
      this.editor.editor_selected = false;
      this.editor.drag = false;
      this.loading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      axios.get(this.apiUrl + `/flows/${flowId}/nodes/${instanceId}/settings`, config).then((response) => {
        const ttsSettings = response.data;
        axios.get(this.apiUrl + `/flows/${flowId}/nodes/${instanceId}/tts`, config).then((response) => {
          const ttsData = response.data;
          if (ttsData.length == 0 && ttsSettings.length == 0) {
            this.$buefy.toast.open({
              duration: 2000,
              message: `This module does not have any settings or tts`,
              type: "is-danger",
            });
            this.loading = false;
          } else {
            this.open = true;
            this.openInstanceId = instanceId;
            this.instanceTTS = ttsData;
            this.instanceSettings = ttsSettings;
            this.loading = false;
            if (this.activeTab == 0 && this.instanceSettings.length == 0) {
              this.activeTab = 1;
            }
            if (this.activeTab == 1 && this.instanceTTS.length == 0) {
              this.activeTab = 0;
            }
          }
        });
      });
    },
    saveSidebar: async function () {
      try {
        this.loading = true;
        var instanceId = this.openInstanceId;

        const tasks = [];

        const token = await this.$cognitoAuth.getIdToken();
        const config = {
          headers: { Authorization: `Bearer ` + token },
        };

        for (const setting of this.instanceSettings) {
          tasks.push(axios.put(this.apiUrl + `/flows/${flowId}/nodes/${instanceId}/settings`, setting, config));
        }
        for (const tts of this.instanceTTS) {
          tasks.push(axios.put(this.apiUrl + `/flows/${flowId}/nodes/${instanceId}/tts`, tts, config));
        }

        await Promise.all(tasks);

        this.$buefy.toast.open({
          message: "Successfully saved!",
          type: "is-success",
        });
        this.openSidebar(instanceId);
      } catch (error) {
        console.error(error);
        this.$buefy.toast.open({
          message: "An error occurred! If this persists, please contact support",
          type: "is-danger",
        });
      }
    },
    closeSidebar: function () {
      this.open = false;
      this.openInstanceId = -1;
      this.doubleClickLastClick = Date.now();
      this.doubleClickId = -1;
    },
    poll: function () {
      var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function () {
        if (this.readyState == 4) {
          if (this.status == 401) {
            window.location.href = "<?= $redirectDir  ?>";
          }
        }
      };
      xhttp.open("GET", "lockFlow.php?session_id=<?= session_id() ?>&flow_id=" + flowId, true);
      xhttp.send();

      setTimeout(this.poll, 5000);
    },
    GetLanguages: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      axios.get(this.apiUrl + "/languages", config).then((response) => {
        this.languages = response.data;
        this.languages.forEach((language) => {
          language.enabled = true;
        });
      });
    },
    GetQueues: async function () {
      this.queues = [
        {
          queue: "defaultqueue",
          label: "",
        },
      ];
    },
    GetAgents: async function () {
      this.agents = [];
    },
    GetTimezones: function () {
      this.timezones = moment.tz.names();
    },
  },
  async created() {
    this.poll();
    this.GetLanguages();
    this.GetQueues();
    this.GetAgents();
    this.GetCompanies();
    this.GetTimezones();
    const token = await this.$cognitoAuth.getIdToken();
    const config = {
      headers: { Authorization: `Bearer ` + token },
    };
    axios.get(this.apiUrl + "/modules", config).then((response) => {
      this.flow = response.data;

      this.flow.sort((a, b) => (a.module_name.toLowerCase() > b.module_name.toLowerCase() ? 1 : b.module_name.toLowerCase() > a.module_name.toLowerCase() ? -1 : 0));

      //Begin UI stuffs
      this.initFlowy();

      window.addEventListener("scroll", this.handleScroll);
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#vapp {
  height: calc(100% - 50px);
  margin: 0;
}

.leftBar {
  height: 100%;
  border-right: 2px solid black;
  margin: 0;
  display: inline-block;
}

.leftBar .blockelem {
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
}

.block {
  background-color: #fff;
  margin-top: 0px !important;
  box-shadow: 0px 4px 30px rgba(22, 33, 74, 0.05);
}

#canvas {
  position: absolute;
  width: calc(100% - 220px);
  height: calc(100% - 50px);
  top: 50px;
  left: 220px;
}

.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.blockelem {
  border: 2px solid black;
  border-radius: 5px;
  width: 200px;
  text-align: center;
  font-size: large;
  transition-property: box-shadow, height;
  transition-duration: 0.2s;
  transition-timing-function: cubic-bezier(0.05, 0.03, 0.35, 1);
  border-radius: 5px;
  box-shadow: 0px 0px 30px rgba(22, 33, 74, 0);
  box-sizing: border-box;
  margin: 5px 10px 5px 10px;
}

.arrowblock {
  color: black;
}

.buttonGroup {
  position: absolute;
  bottom: 10px;
  width: 220px;
}

.button.save {
  width: 90%;
  margin: 5px 5%;
}

html {
  overflow-y: hidden;
}

.wrapper {
  width: 100%;
  height: calc(100vh - 67px);
  display: flex;
}

.col {
  width: 230px;
  height: 100%;
  border-right: 1px solid var(--border-color);
  overflow-x: hidden;
}

.col-right {
  width: calc(100% - 230px);
}

.drag-drawflow {
  line-height: 50px;
  border-bottom: 1px solid var(--border-color);
  padding-left: 20px;
  cursor: move;
  user-select: none;
}

.btn-export {
  float: right;
  position: absolute;
  top: 10px;
  right: 10px;
  color: white;
  font-weight: bold;
  border: 1px solid #0e5ba3;
  background: #4ea9ff;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
  z-index: 5;
}

.btn-clear {
  float: right;
  position: absolute;
  top: 10px;
  right: 85px;
  color: white;
  font-weight: bold;
  border: 1px solid #96015b;
  background: #e3195a;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
  z-index: 5;
}

.swal-wide {
  width: 80% !important;
}

.btn-lock {
  float: right;
  position: absolute;
  bottom: 10px;
  right: 140px;
  display: flex;
  font-size: 24px;
  color: white;
  padding: 5px 10px;
  background: #555555;
  border-radius: 4px;
  border-right: 1px solid var(--border-color);
  z-index: 5;
  cursor: pointer;
}

.bar-zoom {
  float: right;
  position: absolute;
  bottom: 10px;
  right: 10px;
  display: flex;
  font-size: 24px;
  color: white;
  padding: 5px 10px;
  background: #555555;
  border-radius: 4px;
  border-right: 1px solid var(--border-color);
  z-index: 5;
}

.bar-zoom svg {
  cursor: pointer;
  padding-left: 10px;
}

.bar-zoom svg:nth-child(1) {
  padding-left: 0px;
}

#drawflow {
  position: relative;
  width: 100%;
  height: 100%;
  background: var(--background-color);
  background-size: 25px 25px;
  background-image: linear-gradient(to right, #f1f1f1 1px, transparent 1px), linear-gradient(to bottom, #f1f1f1 1px, transparent 1px);
}

.drawflow .drawflow-node {
  display: flex;
  align-items: center;
  position: absolute;
  background: #0ff;
  width: unset;
  min-height: 40px;
  border-radius: 4px;
  border: 2px solid #000;
  color: #000;
  z-index: 2;
  padding: 13px;
}

@media only screen and (max-width: 768px) {
  .col {
    width: 50px;
  }

  .col .drag-drawflow span {
    display: none;
  }

  #drawflow {
    width: calc(100vw - 51px);
  }
}

.b-sidebar .sidebar-content {
  width: 30% !important;
}

.b-tabs .tabs {
  background-color: #d8d8d8;
}

#sidebarCross {
  font-size: 30px;
  padding-right: 10px;
  position: absolute;
  right: 0;
  cursor: pointer;
}

label {
  width: unset;
  float: unset;
  text-align: unset;
  margin-right: unset;
  line-height: unset;
}

#right-click-menu {
  background: #fafafa;
  border: 1px solid #bdbdbd;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  display: block;
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  width: 250px;
  z-index: 999999;
}

#right-click-menu li {
  border-bottom: 1px solid #e0e0e0;
  margin: 0;
  padding: 5px 35px;
}

#right-click-menu li:last-child {
  border-bottom: none;
}

#right-click-menu li:hover {
  background: #1e88e5;
  color: #fafafa;
}

::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #a9a9a9;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

:root {
  --dfBackgroundColor: rgba(218, 224, 230, 1);
  --dfBackgroundSize: 24px;
  --dfBackgroundImage: linear-gradient(to right, rgba(255, 255, 255, 1) 1px, transparent 1px), linear-gradient(to bottom, rgba(255, 255, 255, 1) 1px, transparent 1px);

  --dfNodeType: flex;
  --dfNodeTypeFloat: none;
  --dfNodeBackgroundColor: rgba(71, 208, 97, 1);
  --dfNodeTextColor: rgba(255, 255, 255, 1);
  --dfNodeBorderSize: 0px;
  --dfNodeBorderColor: rgba(255, 255, 255, 1);
  --dfNodeBorderRadius: 4px;
  --dfNodeMinHeight: 40px;
  --dfNodeMinWidth: 160px;
  --dfNodePaddingTop: 15px;
  --dfNodePaddingBottom: 15px;
  --dfNodeBoxShadowHL: 0px;
  --dfNodeBoxShadowVL: 0px;
  --dfNodeBoxShadowBR: 0px;
  --dfNodeBoxShadowS: 1px;
  --dfNodeBoxShadowColor: rgba(66, 188, 89, 1);

  --dfNodeHoverBackgroundColor: rgba(71, 208, 97, 1);
  --dfNodeHoverTextColor: rgba(255, 255, 255, 1);
  --dfNodeHoverBorderSize: 0px;
  --dfNodeHoverBorderColor: rgba(71, 170, 97, 1);
  --dfNodeHoverBorderRadius: 4px;

  --dfNodeHoverBoxShadowHL: 0px;
  --dfNodeHoverBoxShadowVL: 0px;
  --dfNodeHoverBoxShadowBR: 15px;
  --dfNodeHoverBoxShadowS: 0px;
  --dfNodeHoverBoxShadowColor: rgba(71, 208, 97, 1);

  --dfNodeSelectedBackgroundColor: rgba(68, 194, 92, 1);
  --dfNodeSelectedTextColor: #ffffff;
  --dfNodeSelectedBorderSize: 0px;
  --dfNodeSelectedBorderColor: rgba(71, 208, 97, 1);
  --dfNodeSelectedBorderRadius: 4px;

  --dfNodeSelectedBoxShadowHL: 0px;
  --dfNodeSelectedBoxShadowVL: 0px;
  --dfNodeSelectedBoxShadowBR: 15px;
  --dfNodeSelectedBoxShadowS: 0px;
  --dfNodeSelectedBoxShadowColor: rgba(71, 208, 97, 1);

  --dfInputBackgroundColor: #ffffff;
  --dfInputBorderSize: 2px;
  --dfInputBorderColor: #000000;
  --dfInputBorderRadius: 50px;
  --dfInputLeft: -27px;
  --dfInputHeight: 20px;
  --dfInputWidth: 20px;

  --dfInputHoverBackgroundColor: #ffffff;
  --dfInputHoverBorderSize: 2px;
  --dfInputHoverBorderColor: #000000;
  --dfInputHoverBorderRadius: 50px;

  --dfOutputBackgroundColor: #ffffff;
  --dfOutputBorderSize: 2px;
  --dfOutputBorderColor: #000000;
  --dfOutputBorderRadius: 50px;
  --dfOutputRight: -3px;
  --dfOutputHeight: 20px;
  --dfOutputWidth: 20px;

  --dfOutputHoverBackgroundColor: #ffffff;
  --dfOutputHoverBorderSize: 2px;
  --dfOutputHoverBorderColor: #000000;
  --dfOutputHoverBorderRadius: 50px;

  --dfLineWidth: 5px;
  --dfLineColor: rgba(26, 46, 68, 1);
  --dfLineHoverColor: rgba(26, 46, 68, 1);
  --dfLineSelectedColor: rgb(56 95 138);

  --dfRerouteBorderWidth: 2px;
  --dfRerouteBorderColor: #000000;
  --dfRerouteBackgroundColor: #ffffff;

  --dfRerouteHoverBorderWidth: 2px;
  --dfRerouteHoverBorderColor: #000000;
  --dfRerouteHoverBackgroundColor: #ffffff;

  --dfDeleteDisplay: block;
  --dfDeleteColor: #ffffff;
  --dfDeleteBackgroundColor: #000000;
  --dfDeleteBorderSize: 2px;
  --dfDeleteBorderColor: #ffffff;
  --dfDeleteBorderRadius: 50px;
  --dfDeleteTop: -15px;

  --dfDeleteHoverColor: #000000;
  --dfDeleteHoverBackgroundColor: #ffffff;
  --dfDeleteHoverBorderSize: 2px;
  --dfDeleteHoverBorderColor: #000000;
  --dfDeleteHoverBorderRadius: 50px;
}

#drawflow {
  background: var(--dfBackgroundColor);
  background-size: var(--dfBackgroundSize) var(--dfBackgroundSize);
  background-image: var(--dfBackgroundImage);
}

.drawflow .drawflow-node {
  display: var(--dfNodeType);
  background: var(--dfNodeBackgroundColor);
  color: var(--dfNodeTextColor);
  border: var(--dfNodeBorderSize) solid var(--dfNodeBorderColor);
  border-radius: var(--dfNodeBorderRadius);
  min-height: var(--dfNodeMinHeight);
  width: auto;
  min-width: var(--dfNodeMinWidth);
  padding-top: var(--dfNodePaddingTop);
  padding-bottom: var(--dfNodePaddingBottom);
  -webkit-box-shadow: var(--dfNodeBoxShadowHL) var(--dfNodeBoxShadowVL) var(--dfNodeBoxShadowBR) var(--dfNodeBoxShadowS) var(--dfNodeBoxShadowColor);
  box-shadow: var(--dfNodeBoxShadowHL) var(--dfNodeBoxShadowVL) var(--dfNodeBoxShadowBR) var(--dfNodeBoxShadowS) var(--dfNodeBoxShadowColor);
}

.drawflow .drawflow-node:hover {
  background: var(--dfNodeHoverBackgroundColor);
  color: var(--dfNodeHoverTextColor);
  border: var(--dfNodeHoverBorderSize) solid var(--dfNodeHoverBorderColor);
  border-radius: var(--dfNodeHoverBorderRadius);
  -webkit-box-shadow: var(--dfNodeHoverBoxShadowHL) var(--dfNodeHoverBoxShadowVL) var(--dfNodeHoverBoxShadowBR) var(--dfNodeHoverBoxShadowS) var(--dfNodeHoverBoxShadowColor);
  box-shadow: var(--dfNodeHoverBoxShadowHL) var(--dfNodeHoverBoxShadowVL) var(--dfNodeHoverBoxShadowBR) var(--dfNodeHoverBoxShadowS) var(--dfNodeHoverBoxShadowColor);
}

.drawflow .drawflow-node.selected {
  background: var(--dfNodeSelectedBackgroundColor);
  color: var(--dfNodeSelectedTextColor);
  border: var(--dfNodeSelectedBorderSize) solid var(--dfNodeSelectedBorderColor);
  border-radius: var(--dfNodeSelectedBorderRadius);
  -webkit-box-shadow: var(--dfNodeSelectedBoxShadowHL) var(--dfNodeSelectedBoxShadowVL) var(--dfNodeSelectedBoxShadowBR) var(--dfNodeSelectedBoxShadowS) var(--dfNodeSelectedBoxShadowColor);
  box-shadow: var(--dfNodeSelectedBoxShadowHL) var(--dfNodeSelectedBoxShadowVL) var(--dfNodeSelectedBoxShadowBR) var(--dfNodeSelectedBoxShadowS) var(--dfNodeSelectedBoxShadowColor);
}

.drawflow .drawflow-node .input {
  left: var(--dfInputLeft);
  background: var(--dfInputBackgroundColor);
  border: var(--dfInputBorderSize) solid var(--dfInputBorderColor);
  border-radius: var(--dfInputBorderRadius);
  height: var(--dfInputHeight);
  width: var(--dfInputWidth);
}

.drawflow .drawflow-node .input:hover {
  background: var(--dfInputHoverBackgroundColor);
  border: var(--dfInputHoverBorderSize) solid var(--dfInputHoverBorderColor);
  border-radius: var(--dfInputHoverBorderRadius);
}

.drawflow .drawflow-node .outputs {
  float: var(--dfNodeTypeFloat);
}

.drawflow .drawflow-node .output {
  right: var(--dfOutputRight);
  background: var(--dfOutputBackgroundColor);
  border: var(--dfOutputBorderSize) solid var(--dfOutputBorderColor);
  border-radius: var(--dfOutputBorderRadius);
  height: var(--dfOutputHeight);
  width: var(--dfOutputWidth);
}

.drawflow .drawflow-node .output:hover {
  background: var(--dfOutputHoverBackgroundColor);
  border: var(--dfOutputHoverBorderSize) solid var(--dfOutputHoverBorderColor);
  border-radius: var(--dfOutputHoverBorderRadius);
}

.drawflow .connection .main-path {
  stroke-width: var(--dfLineWidth);
  stroke: var(--dfLineColor);
}

.drawflow .connection .main-path:hover {
  stroke: var(--dfLineHoverColor);
}

.drawflow .connection .main-path.selected {
  stroke: var(--dfLineSelectedColor);
}

.drawflow .connection .point {
  stroke: var(--dfRerouteBorderColor);
  stroke-width: var(--dfRerouteBorderWidth);
  fill: var(--dfRerouteBackgroundColor);
}

.drawflow .connection .point:hover {
  stroke: var(--dfRerouteHoverBorderColor);
  stroke-width: var(--dfRerouteHoverBorderWidth);
  fill: var(--dfRerouteHoverBackgroundColor);
}

.drawflow-delete {
  display: var(--dfDeleteDisplay);
  color: var(--dfDeleteColor);
  background: var(--dfDeleteBackgroundColor);
  border: var(--dfDeleteBorderSize) solid var(--dfDeleteBorderColor);
  border-radius: var(--dfDeleteBorderRadius);
}

.parent-node .drawflow-delete {
  top: var(--dfDeleteTop);
}

.drawflow-delete:hover {
  color: var(--dfDeleteHoverColor);
  background: var(--dfDeleteHoverBackgroundColor);
  border: var(--dfDeleteHoverBorderSize) solid var(--dfDeleteHoverBorderColor);
  border-radius: var(--dfDeleteHoverBorderRadius);
}
</style>
